import { ReactNode } from 'react'
import { RouteAccessDeniedDialog } from './RouteAccessDeniedDialog'

export const RouteAccessDenied = ({
  customComponent,
}: {
  customComponent?: ReactNode
}) => {
  return customComponent ? customComponent : <RouteAccessDeniedDialog open />
}
